"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { NotificationBell } from "@repo/ui";
import { useApiClient } from "@repo/api-client";
import { useMessages } from "@/locales";

export function PortalNotificationBell() {
  const zhCN = useMessages();

  const api = useApiClient();
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ["notifications"],
    queryFn: () => api.notifications.list({ limit: 20 }),
    refetchInterval: 30_000,
  });

  const markRead = useMutation({
    mutationFn: (id: string) => api.notifications.markRead(id),
    onSuccess: () =>
      void qc.invalidateQueries({ queryKey: ["notifications"] }),
  });

  return (
    <NotificationBell
      items={query.data?.items ?? []}
      loading={query.isLoading}
      title={zhCN.notifications.title}
      empty={zhCN.notifications.empty}
      markReadLabel={zhCN.notifications.markRead}
      ariaLabel={zhCN.notifications.ariaLabel}
      onMarkRead={(id) => markRead.mutate(id)}
    />
  );
}
